<script setup>
import { computed, onMounted } from 'vue';
import { ClusterOverview } from '@phx-styleguides/iwc';

import CollectionSlider from '@maison/components/organisms/slider/CollectionSlider.vue';
import PictureLazy from '@maison/components/common/PictureLazy.vue';
import { PhxSpecsTable } from '@sg/src/View/Components/Molecules/SpecsTable';
import { PhxGridLayout } from '@sg/src/View/Components/Atoms/GridLayout';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  clusters: {
    type: Array,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

const getClusterSpecs = (cluster, $t) =>
  computed(() => [
    {
      left: $t('VerticalCluster.sizes'),
      right: cluster.sizes,
    },
    {
      left: $t('VerticalCluster.variants', { count: cluster.productsCount }),
    },
  ]);

onMounted(() => {
  const verticalCluster = document.getElementById(props.id);

  if (verticalCluster) {
    new ClusterOverview(verticalCluster);
  }
});
</script>

<template>
  <phx-grid-layout class="vertical-cluster__grid vertical-cluster__content-wrapper" :has-center-classes="false">
    <div
      v-for="(cluster, i) in clusters"
      :id="cluster.id"
      :key="cluster.id"
      :class="['vertical-cluster__content', { 'vertical-cluster__content--visible': i === 0 }]"
      :data-index="i + 1"
    >
      <div class="vertical-cluster__infos">
        <h2 class="vertical-cluster__title heading-large">
          <span>{{ cluster.title }}</span>
        </h2>

        <phx-specs-table :specs="getClusterSpecs(cluster, $t).value" hide-first-divider hide-last-divider />
      </div>

      <div class="vertical-cluster__slider md:hidden">
        <collection-slider :id="`${id}-${cluster.id}-slider`" :slides="cluster.slides" />

        <a :href="cluster.href" class="btn vertical-cluster__collection-cta btn--fade">
          <span class="btn__text">{{ $t('VerticalCluster.viewCollection') }}</span>
        </a>
      </div>

      <a :href="cluster.href" class="btn vertical-cluster__collection-cta max-sm:hidden btn--fade">
        <span class="btn__text">{{ $t('VerticalCluster.viewCollection') }}</span>
      </a>
    </div>
  </phx-grid-layout>

  <phx-grid-layout class="vertical-cluster__grid vertical-cluster__medias" :has-center-classes="false">
    <div
      v-for="(cluster, i) in clusters"
      :key="`${id}-${cluster.id}-${i}-media`"
      class="vertical-cluster__picture-wrapper"
      :data-index="i + 1"
    >
      <div class="picture picture--contain vertical-cluster__picture">
        <picture-lazy v-bind="cluster.image" />
      </div>

      <div class="vertical-cluster__slider max-sm:hidden">
        <collection-slider :id="`${id}-${cluster.id}-slider-media`" :slides="cluster.slides" />
      </div>
    </div>
  </phx-grid-layout>
</template>
